<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 600px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span class="text-subtitle1">{{ selectedCustomer.Cs_Name }}</span>
        <q-badge align="top" class="q-mr-xs" color="deep-orange-14">
          <i>شناسه(</i><b>{{ selectedCustomer.Cs_Code }}</b><i>)</i>
        </q-badge>
        <q-badge align="top" v-if="selectedCustomer.State_Name!=='' && selectedCustomer.State_Name"
                 :label="selectedCustomer.State_Name" color="brown-5"/>
        <q-badge align="top" v-if="selectedCustomer.City_Name!=='' && selectedCustomer.City_Name"
                 :label="selectedCustomer.City_Name" color="brown-5" class="q-ml-xs"/>
        <q-badge align="top" v-if="selectedCustomer.Zone_Name!=='' && selectedCustomer.Zone_Name"
                 :label="selectedCustomer.Zone_Name" color="brown-5" class="q-ml-xs"/>
        <q-badge align="top" class="q-ml-xs" v-if="selectedCustomer.Archived" label="آرشیو" color="grey"
                 text-color="white"/>
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup v-if="dialog"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="generalInfoOnly" class="text-center">
      <q-chip v-if="selectedCustomer.RemCredit > 0" square color="deep-orange-14"
              size="lg"
              icon="attach_money" outline>بدهکاری
        <q-badge color="red" text-color="white" class="q-ml-xs">
          {{ Math.abs(selectedCustomer.RemCredit) | toCurrency }} ریال
        </q-badge>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding" v-if="!generalInfoOnly">
      <div class="row full-width">
        <div class="col-md-6 col-xs-12">
          <q-chip v-if="selectedCustomer.RemCredit > 0" size="sm" square color="deep-orange-14"
                  icon="attach_money" outline>بدهکاری
            <q-badge color="red" text-color="white" class="q-ml-xs">
              {{ Math.abs(selectedCustomer.RemCredit) | toCurrency }} ریال
            </q-badge>
          </q-chip>
          <q-chip size="sm" square color="deep-orange-14" icon="event" outline>شروع فعالیت <b
              class="q-ml-xs">{{ selectedCustomer.Cs_Begin }}</b>
            <q-badge color="red" text-color="white" class="q-ml-xs">{{ saleInfo.totalContactYears }} سال
            </q-badge>
          </q-chip>
          <q-space/>
          <q-chip size="sm" square color="red-10" icon="calendar_today" outline>
            <b>{{
                saleInfo.idleTimeYears === 0 ? 'عدم فعالیت کمتر از یکسال می باشد' : 'عدم فعالیت به مدت'
              }}</b>
            <q-badge color="red-10" text-color="white" class="q-ml-xs" v-if="saleInfo.idleTimeYears!==0">
              {{ saleInfo.idleTimeYears }} سال
            </q-badge>
          </q-chip>
          <q-chip size="sm" square color="red-10" icon="calendar_today" outline
                  clickable
                  @click="loadPayAndBook">
            <b>چک های پاس نشده</b>
            <q-badge color="red-10" text-color="white" class="q-ml-xs text-bold">
              {{
                cheque_note_pass ? `${cheque_note_pass.toLocaleString()} ریال` : 'بررسی نشده'
              }}
            </q-badge>
          </q-chip>
          <q-space/>
          <q-chip v-if="selectedCustomer.AgentRegisterInfo" :label="`ثبت کننده(${selectedCustomer.AgentRegisterInfo})`"
                  square/>
        </div>
        <div :class="$q.screen.lt.md?'col-md-6 col-xs-12 text-center':'col-md-6 col-xs-12 text-right'"
             v-if="!generalInfoOnly">
          <q-card flat>
            <q-card-section class="no-padding">
              <q-chip size="sm" color="red-10" text-color="white" label="ریسک معامله"/>
            </q-card-section>
            <q-card-section class="no-padding">
              <q-circular-progress
                  show-value
                  font-size="20px"
                  :value="100 - selectedCustomer.CustomerValue"
                  size="80px"
                  :thickness="0.22"
                  color="red-10"
                  track-color="grey-3"
                  class="no-padding">
                {{ 100 - selectedCustomer.CustomerValue }}%
              </q-circular-progress>
            </q-card-section>
          </q-card>
        </div>
      </div>


    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip v-for="(item, index) in JSON.parse(selectedCustomer.tags)"
              :key="`tags-${index}`"
              icon="tag" square
              size="sm"
              :label="item.TagName"/>
    </q-card-section>
    <q-card-section class="q-pa-xs no-padding">
      <q-banner dense v-if="selectedCustomer.Cs_Address1"
                inline-actions rounded
                class="bg-grey-3 no-padding q-mb-xs">
        <template v-slot:avatar>
          <q-icon name="location_on" size="md" color="indigo"/>
        </template>
        <span>{{ selectedCustomer.Cs_Address1 }}</span>
      </q-banner>
      <q-banner dense v-if="selectedCustomer.Cs_Address2"
                inline-actions rounded
                class="bg-grey-3 no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-icon name="location_on" size="md" color="indigo"/>
        </template>
        <span>{{ selectedCustomer.Cs_Address2 }}</span>
      </q-banner>

      <q-banner dense v-if="selectedCustomer.Cs_ShopName"
                inline-actions rounded
                class="bg-grey-3 no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-icon name="location_on" size="md" color="indigo"/>
        </template>
        <span>{{ selectedCustomer.Cs_ShopName }}</span>
      </q-banner>
    </q-card-section>

    <q-card-section class="q-pa-xs no-padding">
      <q-banner dense v-if="selectedCustomer.Cs_Tel1" inline-actions rounded
                class="bg-primary text-white no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-btn flat icon="local_phone" @click="dial(selectedCustomer.Cs_Tel1.replace('061',''))"/>
        </template>
        <span class="text-bold">{{ selectedCustomer.Cs_Tel1 | toOnlyNumeric }}</span>
      </q-banner>
      <q-banner dense v-if="selectedCustomer.Cs_Tel2" inline-actions rounded
                class="bg-secondary text-white no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-btn flat icon="local_phone" @click="dial(selectedCustomer.Cs_Tel2)"/>
        </template>
        <span class="text-bold">{{ selectedCustomer.Cs_Tel2 | toOnlyNumeric }}</span>
      </q-banner>
      <q-banner dense v-if="selectedCustomer.Cs_Fax" inline-actions rounded
                class="bg-indigo text-white no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-btn flat icon="print" @click="dial(selectedCustomer.Cs_Fax)"/>
        </template>
        <span class="text-bold">{{ selectedCustomer.Cs_Fax | toOnlyNumeric }}</span>
      </q-banner>
      <q-banner dense v-if="selectedCustomer.Cs_ZipCode && selectedCustomer.Cs_ZipCode!=='None'" inline-actions rounded
                class="bg-primary text-white no-padding q-ma-xs">
        <b>کد پستی:</b><span class="text-bold">{{ selectedCustomer.Cs_ZipCode }}</span>
        <template v-slot:avatar>
          <q-btn disable flat icon="location_city"/>
        </template>
      </q-banner>
    </q-card-section>

    <q-card-section class="q-pa-xs no-padding">
      <q-banner dense v-if="selectedCustomer.Cs_Mobile" inline-actions rounded
                class="bg-primary text-white no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-btn flat icon="smartphone" @click="dial(selectedCustomer.Cs_Mobile)"/>
        </template>
        <span class="text-bold">{{ selectedCustomer.Cs_Mobile | toOnlyNumeric }}</span>
      </q-banner>
      <q-banner dense v-if="selectedCustomer.Cs_Mobile2" inline-actions rounded
                class="bg-secondary text-white no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-btn flat icon="smartphone" @click="dial(selectedCustomer.Cs_Mobile2)"/>
        </template>
        <span class="text-bold">{{ selectedCustomer.Cs_Mobile2 | toOnlyNumeric }}</span>
      </q-banner>
    </q-card-section>

    <q-card-section class="q-pa-xs no-padding" v-if="selectedCustomer.Cs_Desc && selectedCustomer.Cs_Desc!=='None'">
      <q-banner dense class="bg-grey-3">
        <template v-slot:avatar>
          <q-icon name="comment" size="md" color="red"/>
        </template>
        <span style="white-space: pre-wrap;">{{ selectedCustomer.Cs_Desc }}</span>
      </q-banner>
    </q-card-section>
    <q-separator/>
    <q-card-section class="q-pa-xs no-padding" v-if="!generalInfoOnly">
      <q-banner dense inline-actions rounded
                class="bg-green-10 text-white no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-icon name="attach_money" size="md"/>
        </template>
        <q-chip :size="$q.screen.lt.md?'md':'md'" label="اعتبار ریـــالی">
          <q-badge color="red-14 q-ma-xs">{{ selectedCustomer.Cs_BDRial | toCurrency }}</q-badge>
        </q-chip>
        <template v-slot:action
                  v-if="$store.state.roles.some(v=>['admin','can_set_license_to_determine_the_validity_of_checks'].includes(v))">
          <q-btn flat icon="edit">
            <q-popup-proxy>
              <q-banner>
                <div>
                  <div class="text-bold">{{ selectedCustomer.Cs_Name }}</div>
                  <q-badge class="bg-red-14"><i>شناسه(</i><b>{{
                      selectedCustomer.Cs_Code
                    }}</b><i>)</i></q-badge>
                </div>
                <template v-slot:avatar>
                  <q-icon name="edit" color="primary"/>
                </template>
                <q-form
                    autofocus
                    class="q-gutter-md q-gutter-sm"
                    @submit="onSubmit('Cs_BDRial')">
                  <q-card-section>
                    <q-field
                        v-model="selectedCustomer.Cs_BDRial"
                        mask="currency"
                        label="اعتبار ریالی"
                        label-color="indigo"
                        autofocus
                        dir="ltr"
                        lazy-rules
                        :rules="[
                                        val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'اعتبار ریالی را وارد نمایید',
                                        val => parseInt(val.toString().replaceAll(',','')) >= 0  || 'اعتبار ریالی عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                      ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value)"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                    <div class="items-center justify-end row no-padding q-mt-ma q-mt-lg">
                      <q-btn color="primary" type="submit" label="تایید" icon="check"
                             v-close-popup/>
                      <q-btn flat label="انصراف" color="red" icon="cancel" v-close-popup/>
                    </div>
                  </q-card-section>
                </q-form>
              </q-banner>
            </q-popup-proxy>
          </q-btn>
        </template>
      </q-banner>
      <q-banner dense inline-actions rounded
                class="bg-light-green-8 text-white no-padding q-ma-xs">
        <template v-slot:avatar>
          <q-icon name="attach_money" size="md"/>
        </template>
        <q-chip :size="$q.screen.lt.md?'md':'md'" label="اعتبار اسنادی">
          <q-badge color="light-green-10 q-ma-xs">{{ selectedCustomer.Cs_BDChek | toCurrency }}</q-badge>
        </q-chip>
        <template v-slot:action
                  v-if="$store.state.roles.some(v=>['admin','can_set_license_to_determine_the_validity_of_checks'].includes(v))">
          <q-btn flat icon="edit">
            <q-popup-proxy>
              <q-banner>
                <template v-slot:avatar>
                  <q-icon name="edit" color="primary"/>
                </template>
                <q-form
                    autofocus
                    greedy
                    class="q-gutter-md q-gutter-sm"
                    @submit="onSubmit('Cs_BDChek')">
                  <q-card-section>
                    <q-field
                        v-model="selectedCustomer.Cs_BDChek"
                        mask="currency"
                        label="اعتبار اسنادی"
                        autofocus
                        dir="ltr"
                        label-color="indigo"
                        lazy-rules
                        :rules="[
                                        val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'اعتبار ریالی را وارد نمایید',
                                        val => parseInt(val.toString().replaceAll(',','')) >= 0  || 'اعتبار ریالی عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                      ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value)"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                    <div class="items-center justify-end row no-padding q-mt-ma q-mt-lg">
                      <q-btn color="primary" type="submit" label="تایید" icon="check"
                             v-close-popup/>
                      <q-btn flat label="انصراف" color="red" icon="cancel" v-close-popup/>
                    </div>
                  </q-card-section>
                </q-form>
              </q-banner>
            </q-popup-proxy>
          </q-btn>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="q-pa-xs no-padding" v-if="!generalInfoOnly">
      <q-btn-group spread>
        <q-btn color="purple" icon="location_on" @click="SetCurrentCustomerLocation">
          <q-tooltip>
            ثبت موقعیت جغرافیایی
          </q-tooltip>
        </q-btn>
        <q-btn color="purple" icon="insert_invitation"
               @click="showTimeLine()">
          <q-tooltip>
            چارت زمانی فعالیت
          </q-tooltip>
        </q-btn>
        <q-btn color="purple" icon="history" @click="showOrderHistory">
          <q-tooltip>
            لیست سفارشات
          </q-tooltip>
        </q-btn>
        <q-btn color="purple" icon="history_edu" @click="showFactorHistory">
          <q-tooltip>
            لیست فاکتورهای طرف معامله
          </q-tooltip>
        </q-btn>
        <q-btn color="purple" icon="analytics" @click="showGoodsGroupDialog">
          <q-tooltip>
            گروه های کالایی پر کاربرد طرف معامله
          </q-tooltip>
        </q-btn>
        <q-btn color="purple" icon="credit_score"
               v-if="($store.state.roles.some(v=>['can_see_customer_finance_document'].includes(v)) && selectedCustomer.CsSpe_ID===2) || $store.state.roles.some(v=>['admin'].includes(v))"
               @click="showFinanceInfo">
          <q-tooltip>
            مشاهده معین طرف معامله
          </q-tooltip>
        </q-btn>
        <q-btn v-if="$store.state.roles.some(v=>['admin', 'edit_customer'].includes(v))" color="purple"
               icon="edit" @click="showEditCustomerDialog=true">
          <q-tooltip>
            ویرایش اطلاعات طرف معامله
          </q-tooltip>
        </q-btn>
        <q-btn flat v-if="$store.state.roles.some(v=>['admin', 'send_pay_link'].includes(v))"
               class="bg-purple text-white" icon="payment">
          <q-popup-proxy>
            <q-banner>
              <div>
                <div class="text-bold">{{ selectedCustomer.Cs_Name }}</div>
                <q-badge class="bg-red-14"><i>شناسه(</i><b>{{ selectedCustomer.Cs_Code }}</b><i>)</i>
                </q-badge>
              </div>
              <template v-slot:avatar>
                <q-icon name="edit" color="primary"/>
              </template>
              <q-form
                  autofocus
                  class="q-gutter-md q-gutter-sm"
                  @submit="onSubmitCustomPay">
                <q-card-section>
                  <q-field
                      v-model="CustomPay"
                      mask="currency"
                      label="مبلغ جهت دریافت از طرف معامله"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      lazy-rules
                      :rules="[
                               val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'اعتبار ریالی را وارد نمایید',
                               val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'اعتبار ریالی عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                               ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value)"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>
                  </q-field>
                  <q-input
                      v-model="CustomText"
                      label="شرح مختصر"
                      label-color="indigo"
                      type="text"
                      lazy-rules
                      :rules="[
                               val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'شرخ مختصری در خصوص پرداخت وارد نمایید',
                               ]">
                  </q-input>
                  <div class="items-center justify-end row no-padding q-mt-ma q-mt-lg">
                    <q-btn color="primary" type="submit" label="تایید" icon="check" v-close-popup/>
                    <q-btn flat label="انصراف" color="red" icon="cancel" v-close-popup/>
                  </div>
                </q-card-section>
              </q-form>
            </q-banner>
          </q-popup-proxy>
          <q-tooltip>
            ارسال لینک سفارشی پرداخت
          </q-tooltip>
        </q-btn>
        <q-btn round color="purple" icon="add_task" padding="none" @click="showEvent">
          <q-tooltip>
            ثبت گزارش برای طرف معامله
          </q-tooltip>
        </q-btn>
        <q-btn round color="purple" icon="share" padding="none"
               :size="$q.screen.lt.md?'md':'lg'"
               v-if="$store.state.roles.some(v=>['admin','can_send_sms'].includes(v))"
               @click="shareInfo()">
          <q-tooltip>
            به اشتراک گذاری اطلاعات طرف معامله از طریق پیامک
          </q-tooltip>
        </q-btn>
        <q-btn round color="purple" icon="question_mark" padding="none"
               @click="showQuestionsDialog"
               v-if="($store.state.roles.some(v=>['admin','can_fill_customer_questionaire'].includes(v)))">
          <q-tooltip>
            پرسشنامه طرف معامله
          </q-tooltip>
        </q-btn>
        <q-btn round color="purple" icon="upload_file" padding="none"
               @click="showUploadDialog=true">
          <q-tooltip>
            بارگذاری تصویر
          </q-tooltip>
        </q-btn>
        <q-btn round color="purple" icon="list" padding="none"
               @click="loadGroupReports(selectedCustomer)">
          <q-tooltip>
            مشاهده لیست گروه کالاهایی که این ماه بر روی آن ها فعالیت داشته است
          </q-tooltip>
        </q-btn>
      </q-btn-group>
    </q-card-section>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showOrderHistoryList">
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div>
            <div class="text-bold">سوابق سفارشات <i class="text-indigo-14">{{
                selectedCustomer.Cs_Name
              }}</i></div>
            <q-badge align="top" class="bg-red-14"><i>شناسه(</i><b>{{
                selectedCustomer.Cs_Code
              }}</b><i>)</i>
            </q-badge>
          </div>
          <q-space/>
          <q-btn icon="close" flat round dense v-close-popup/>
        </q-card-section>
        <q-card-section>
          <OrderHistory default-sale-state="1" :order-history-list="orderHistoryList"/>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showGoodsGroupReports">
      <q-card>
        <q-card-section>
          <GoodsGroupReports :order-goods-group-list="orderGoodsGroup" :order-goods-list="GoodsList"
                             :Customer="selectedCustomer"/>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showEditCustomerDialog">
      <q-card>
        <q-card-section class="no-padding">
          <CUCustomerInfo action="edit" :selected-customer-info.sync="selectedCustomer"
                          :buy-list="buyList"
                          @customer-updated="customerUpdated"/>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showVisitLogDialog">
      <visit-log :selectedCustomer="selectedCustomer"/>
    </q-dialog>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showEventDialog">
      <q-card>
        <q-card-section>
          <CUVisitLog @event-added="closeEventDialog" :selected-customer="selectedCustomer"/>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog
        v-model="showFinanceInfoDialog"
        :maximized="$q.screen.lt.md">
      <CustomerFinanceInfo :customer-info="selectedCustomer"/>
    </q-dialog>

    <q-dialog v-model="showCallPanelDialog" :maximized="$q.screen.lt.md">
      <CallPanel :call-number="callNumber" :customer-info="selectedCustomer"/>
    </q-dialog>

    <q-dialog v-if="!buyList" v-model="factorHistoryDialog" :maximized="$q.screen.lt.md">
      <FactorCustomerHistory :order-history-list="factorsList" :is-dialog="true"/>
    </q-dialog>

    <q-dialog v-if="buyList" v-model="buyFactorHistoryDialog" maximized>
      <BuyList
          :compact-view="$q.screen.lt.md"
          :is-dialog="true"
          :is-searching="true"
          :filter="searchKey"
          :default-open="true"
          :read-only="true"
          :items="factorsList"
          :no-price="false"
          :no-order-info="false"
          :title="`لیست فاکتورهای ${selectedCustomer.Cs_Name}`"/>
    </q-dialog>

    <q-dialog v-model="customerReceivePayList" :maximized="$q.screen.lt.md">
      <CustomerReceiveList :customer-info="selectedCustomer"/>
    </q-dialog>

    <q-dialog v-model="showSMSPanel">
      <SMSPanel :customer="selectedCustomer" :share="share" @sms_sended="sms_sended"/>
    </q-dialog>
    <q-dialog v-model="customerQuestionaire" maximized>
      <CustomerQuestions :customer-info="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="showUploadDialog" persistent>
      <UploadCustomerProfileImages :customer-info="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from 'vuex';
import OrderHistory from "@/components/customers/OrderHistory";
import GoodsGroupReports from "@/components/customers/GoodsGroupReports";
import CUCustomerInfo from "@/components/customers/CUCustomerInfo";
import VisitLog from "@/components/customers/VisitLog";
import CUVisitLog from "@/components/customers/CUVisitLog";
import CustomerFinanceInfo from "@/components/customers/CustomerFinanceInfo";
import CallPanel from "@/components/callCenter/CallPanel";
import FactorCustomerHistory from "@/components/Factor/FactorCustomerHistory";
import CustomerReceiveList from "@/components/customers/CustomerReceiveList";
import SMSPanel from "@/components/callCenter/SMSPanel";
import CustomerQuestions from "@/components/CustomerQuestions/CustomerQuestions";
import BuyList from "@/components/Buys/BuyList";
import {Geolocation} from '@capacitor/geolocation';
import UploadCustomerProfileImages from "@/components/customers/UploadCustomerProfileImages.vue";

export default {
  name: "CustomerInfo",
  components: {
    UploadCustomerProfileImages,
    BuyList,
    CustomerQuestions,
    SMSPanel,
    CustomerReceiveList,
    FactorCustomerHistory,
    CallPanel, CustomerFinanceInfo, CUVisitLog, VisitLog, CUCustomerInfo, GoodsGroupReports, OrderHistory
  },
  props: {
    buyList: {
      type: Boolean,
      default: false
    },
    selectedCustomer: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      required: false,
      default: true
    },
    generalInfoOnly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      showUploadDialog: false,
      searchKey: undefined,
      buyFactorHistoryDialog: false,
      share: false,
      showSMSPanel: false,
      customerReceivePayList: false,
      factorHistoryDialog: false,
      showFinanceInfoDialog: false,
      orderHistoryList: [],
      orderGoodsGroup: [],
      GoodsList: [],
      selectedNumnber: '',
      showOrderHistoryList: false,
      showGoodsGroupReports: false,
      showEditCustomerDialog: false,
      showCustomSendPayLinkDialog: false,
      showVisitLogDialog: false,
      showCallPanelDialog: false,
      selectedDeboters: [],
      saleInfo: '',
      CustomPay: '',
      CustomText: '',
      showEventDialog: false,
      factorsList: [],
      customerQuestionaire: false,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      cheque_note_pass:undefined,
      callNumber: 0
    }
  },
  methods: {
    ...mapActions({
      setPayAndBook: 'Customers/getPayAndGetBook',
      ChangeCredit: 'Customers/change_credit',
      ShowOrderHistory: 'Customers/getOrderHistory',
      GetCustomerSaleInfo: 'Orders/getCustomerSaleInfo',
      GetOrdersGoodsGroup: 'Orders/getOrdersGoodsGroup',
      setCurrentCustomerLocation: 'Customers/set_current_location',
      sendMessage: 'sendMessage',
      sendPayList: 'Deboters/sendPayLink',
      getFactory: 'Orders/getFactors',
      getBuyFactorList: 'Buys/getFactorListByCustomerID'
    }),
    async loadPayAndBook() {
      await this.setPayAndBook(this.selectedCustomer.Cs_Code).then((res) => {
        this.cheque_note_pass = res.length > 0 ? this.lodash.sumBy(res, item=> item.getFee) : 0
      })
    },
    async loadGroupReports(rowInfo) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/%DA%AF%D8%B2%D8%A7%D8%B1%D8%B4%D8%A7%D8%AA%20%D9%85%D8%B1%D8%AA%D8%A8%D8%B7%20%D8%A8%D8%A7%20%D9%85%D8%B4%D8%AA%D8%B1%DB%8C%D8%A7%D9%86/%DA%AF%D8%B2%D8%A7%D8%B1%D8%B4%20%D9%81%D8%B1%D9%88%D8%B4%20%D9%85%D8%A7%D9%87%D8%A7%D9%86%D9%87%20%DA%AF%D8%B1%D9%88%D9%87%20%DA%A9%D8%A7%D9%84%D8%A7%20%DA%A9%D8%A7%D8%B1%20%DA%A9%D8%B1%D8%AF%D9%87%20%D9%88%20%DA%A9%D8%A7%D8%B1%20%D9%86%DA%A9%D8%B1%D8%AF%D9%87%20%D8%A8%D9%87%20%D8%A7%D8%B2%D8%A7%DB%8C%20%DB%8C%DA%A9%20%D9%85%D8%B4%D8%AA%D8%B1%DB%8C%20%D8%AF%D8%B1%20%D8%B3%D8%A7%D9%84%20%D8%AC%D8%A7%D8%B1%DB%8C?rs:Format=PDF&Code=${rowInfo.Cs_ID}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    showQuestionsDialog() {
      this.customerQuestionaire = true
    },
    sms_sended() {
      this.showSMSPanel = false
    },
    shareInfo() {
      this.share = true;
      this.showSMSPanel = true
    },
    showFactorHistory() {
      if (!this.buyList) {
        this.getFactory({
          cs_id: this.selectedCustomer.Cs_ID,
          saleKind: 1
        }).then((res) => {
          this.factorsList = res
          this.factorHistoryDialog = true
        })
      } else if (this.buyList) {
        this.getBuyFactorList(this.selectedCustomer.Cs_ID).then((res) => {
          this.factorsList = res.filter(item => item.Factor_Num)
          this.buyFactorHistoryDialog = true
        })
      }
    },
    showFinanceInfo() {
      this.showFinanceInfoDialog = true
    },
    closeEventDialog() {
      this.showEventDialog = false
    },
    showEvent() {
      this.showEventDialog = true
    },
    onSubmit(column) {
      this.ChangeCredit({
        ecap_customer_id: this.selectedCustomer.Cs_ID,
        creditValue: column === 'Cs_BDRial' ? this.selectedCustomer.Cs_BDRial.toString().replaceAll(',', '') : this.selectedCustomer.Cs_BDChek.toString().replaceAll(',', ''),
        field: column,
        Id: null,
        Rejected: 0,
        Reason: null
      }).then((res) => {
        if (res.data.length > 0) {
          if (this.$store.state.roles.some(v => ['salemanager', 'user'].includes(v))) {
            this.$q.notify({
              message: `مبلغ درخواست تغییر اعتبار طرف معامله به ${column === 'Cs_BDRial' ? this.selectedCustomer.Cs_BDRial.toString() : this.selectedCustomer.Cs_BDChek.toString()} ،ارسال گردید. `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          } else {
            this.$q.notify({
              message: `مبلغ اعتبار به ${column === 'Cs_BDRial' ? res.data[0].Cs_BDRial.toLocaleString() : res.data[0].Cs_BDChek.toLocaleString()} تغییر داده شد `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }
      }).catch(() => {
        this.$q.notify({
          message: 'اعتبار تغییر داده نشد',
          color: 'red',
          position: 'top',
          type: 'negative'
        });
      });
    },
    onSubmitCustomPay() {
      if (Math.abs(this.CustomPay) > 500000000) {
        this.$q.notify({
          message: `بدهی طرف معامله بیشتر از سقف انتقال می باشد و امکان ارسال پیامک برای ایشان وجود ندارد`,
          color: 'negative',
          type: 'negative',
          position: 'top'
        });
      } else if (Math.abs(this.CustomPay) === 0) {
        this.$q.notify({
          message: `مبلغ نمی تواند صفر باشد`,
          color: 'negative',
          type: 'negative',
          position: 'top'
        });
      } else if (this.CustomText === '') {
        this.$q.notify({
          message: `ثبت شرح الزامی است`,
          color: 'negative',
          type: 'negative',
          position: 'top'
        });
      } else {
        let customer = this.selectedCustomer;
        customer.Cs_Pay = parseInt(this.CustomPay.toString().replaceAll(',', ''));
        customer.Cs_PayType = 0;
        customer.Cs_Lock = 1;
        customer.CustomText = this.CustomText;
        this.selectedDeboters.push(customer);
        this.SendPayLink(this.selectedDeboters);
      }
    },
    SendPayLink(customers) {
      this.sendPayList(customers).then((data) => {
        if (data.length > 0) {
          this.selectedDeboters = [];
          this.$q.notify({
            message: 'لینک پرداخت ارسال گردید',
            color: 'positive',
            type: 'positive',
            position: 'top'
          });
        }
        this.CustomText = '';
        this.CustomPay = '';
      }).catch(() => {
        this.$q.notify({
          message: 'هم اکنون امکان ارسال لینک پرداخت میسر نمی باشد',
          color: 'negative',
          type: 'negative',
          position: 'top'
        });
        this.CustomText = '';
        this.CustomPay = '';
      });
    },
    showOrderHistory() {
      this.ShowOrderHistory(this.selectedCustomer.Cs_ID).then((res) => {
        this.orderHistoryList = res.data;
        this.showOrderHistoryList = true;
      });
    },
    showGoodsGroupDialog() {
      this.GetOrdersGoodsGroup(this.selectedCustomer.Cs_ID).then((res) => {
        this.orderGoodsGroup = JSON.parse(res.data.goods_group);
        this.GoodsList = JSON.parse(res.data.goods);
        this.showGoodsGroupReports = true;
      });
    },
    async SetCurrentCustomerLocation() {
      const loc = await Geolocation.getCurrentPosition({enableHighAccuracy: true, timeout: 1000}).catch(() => {
        this.$q.notify({
          message: 'امکان دریافت موقعیت جغرافیایی طرف معامله وجود ندارد',
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      })
      this.setCurrentCustomerLocation({
        Cs_ID: this.selectedCustomer.Cs_ID,
        latitude: loc.coords.latitude,
        longitude: loc.coords.longitude,
        accuracy: loc.coords.accuracy
      }).then(() => {
        this.$q.notify({
          message: 'موقعیت جغرافیایی طرف معامله به ثبت رسید',
          color: 'positive',
          position: 'top',
          type: 'positive'
        });
      });
    },
    dial(number) {
      this.callNumber = number;
      this.showCallPanelDialog = true;
    },
    customerUpdated(args) {
      this.$emit('customer-updated', args[0]);
      this.showEditCustomerDialog = false;
    },
    showTimeLine() {
      this.showVisitLogDialog = true;
    },
  },
  created() {
    this.GetCustomerSaleInfo(this.selectedCustomer.Cs_ID).then((res) => {
      this.saleInfo = res.data;
    })
  }
}
</script>

<style scoped>

</style>
